import { render, staticRenderFns } from "./DashboardCardWithdraw.vue?vue&type=template&id=26775d6c&scoped=true&"
import script from "./DashboardCardWithdraw.vue?vue&type=script&lang=js&"
export * from "./DashboardCardWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCardWithdraw.vue?vue&type=style&index=0&id=26775d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26775d6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDataTable,VDivider,VSpacer})
